
const routes = [
    {
        path: '/login',
        component: () => import('#login/pages/Login.svelte'),
        module: () => import('#login/LoginModule.svelte'),
    },
    {
        path: '/forgot-password',
        component: () => import('#login/pages/ForgotPassword.svelte'),
        module: () => import('#login/LoginModule.svelte'),
    },
    {
        path: '/password-reset/:token',
        component: () => import('#login/pages/ResetPassword.svelte'),
        module: () => import('#login/LoginModule.svelte'),
    },
];

export { routes };
